/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
import React from 'react'
import { MWLSelectField } from 'react-web-white-label'
import './DpsSelect.css'
const DpsSelectField = ({
  borderRadius = '4px',
  fieldLabel,

  options = [
    {
      id: '1',
      title: 'Option 1',
    },
    {
      id: '2',
      title: 'Option 2',
    },
    {
      id: '3',
      title: 'Option 3',
    },
  ],
  size = 'medium',
  variant = 'outlined',
  width = '200px',
  disabled = false,
  error = false,
  className,
  placeholder = 'Select ',
  selectChangeHandler = () => {},
  initialValue = null,
}) => {
  return (
    <div className="dps-select-field-container">
      <MWLSelectField
        borderRadius={borderRadius}
        size={size}
        variant={variant}
        disabled={disabled}
        fieldLabel={fieldLabel}
        options={options}
        className={`button btn--${className} dPSSelectComponentSection`}
        selectChangeHandler={selectChangeHandler}
        error={error}
        width={width}
        placeholder={placeholder || 'Select '}
        initialValue={initialValue?.title || null}
      />
    </div>
  )
}

export default DpsSelectField
